import React from "react";

export default function ConfirmSessionCurrency({ deleteUser,cancelRequest, id }) {
  return (
    <div className="confirm-delete-wrapper register-medium">
      <div data-backdrop="static" className="modal fade" id={id} role="dialog">
        <div className="modal-dialog padding-unset modal-dialog-preview">
          <div className="modal-content">
            <div className="modal-body">
             
              <h3>You've changed your currency.</h3>
              <h3>This will update the currency for all your paid services. Do you wish to continue?</h3>
              <div className="confirm-btn-box">
              <div
                  className="register-medium-confirnation"
                  data-dismiss="modal"
                  onClick={deleteUser}
                >
                  Continue & Save
                </div>
                <div
                  className="register-medium-confirnation model-close-btn"
                  onClick={cancelRequest}
                  data-dismiss="modal"
                >
                  No, Keep Editing
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
